import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/es.array.map.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import ShadedCard from 'components/ShadedCard';
import Heading from 'components/Heading';
import Flex from 'components/Flex';
import Box from 'components/Box';
import TextLink from 'components/TextLink';
import Button from 'components/Button';
import Stack from 'components/Stack';
import Text from 'components/Text';
import FormField from 'components/FormField';
import FormStack from 'components/FormStack';
import TextInput from 'components/TextInput';
import Modal from 'components/Modal';
import Card from 'components/Card';
import logoutUser from 'utils/auth/logout';
import { redirectToLogin } from 'utils/auth/getLogoutPath';
import config from 'utils/config';
import { hasPrivilege, SUPER_USER } from 'utils/privileges';
import { useUpdateUserProfile } from 'actions/userProfile';
import { useUpdateMyUserSettings } from 'actions/userSettings';
import { setAlert } from 'actions/alerts';
import { AvatarEditor } from '../../../pages/userSettings/editor';
import { useAuthContext } from '../../../contexts/auth/index';
var AVATAR_EDITOR_WIDTH = 160;

// Define seperately to prevent recreation every state render
// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function noop() {};
function CompleteProfileModal(_ref) {
  var _userProfile$userCust, _userProfile$userCust3;
  var userProfile = _ref.userProfile,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? noop : _ref$onClose;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var _useAuthContext = useAuthContext(),
    setAuthUser = _useAuthContext.setAuthUser;
  var _useUpdateMyUserSetti = useUpdateMyUserSettings(),
    updateUserSettings = _useUpdateMyUserSetti.updateUserSettings;
  var _useUpdateUserProfile = useUpdateUserProfile(),
    updateUserProfile = _useUpdateUserProfile.updateUserProfile;
  var completeProfileMessage = config.completeProfileMessage;

  // config or config.enableUserEditName can be undefined if not toggled before, but we require the default to be TRUE
  var enableUserEditName = config.enableUserEditName !== false;
  var hasFullName = Boolean(userProfile.first_name && userProfile.last_name);
  var hasRequiredFields = (_userProfile$userCust = userProfile.userCustomFields) === null || _userProfile$userCust === void 0 ? void 0 : _userProfile$userCust.some(function (field) {
    return field.is_required;
  });
  function getUserCustomFieldValue() {
    var _userProfile$userCust2;
    var res = {};
    (_userProfile$userCust2 = userProfile.userCustomFields) === null || _userProfile$userCust2 === void 0 ? void 0 : _userProfile$userCust2.forEach(function (f) {
      var value = f.value,
        customfield_id = f.id,
        label = f.label,
        is_required = f.is_required;
      res[label] = {
        value: value,
        customfield_id: customfield_id,
        is_required: is_required
      };
    });
    return res;
  }
  var _useState = useState(!!(!hasFullName && enableUserEditName)),
    _useState2 = _slicedToArray(_useState, 2),
    showNameForm = _useState2[0],
    setShowNameForm = _useState2[1];
  var _useState3 = useState(userProfile.first_name),
    _useState4 = _slicedToArray(_useState3, 2),
    firstName = _useState4[0],
    setFirstName = _useState4[1];
  var _useState5 = useState(userProfile.last_name),
    _useState6 = _slicedToArray(_useState5, 2),
    lastName = _useState6[0],
    setLastName = _useState6[1];
  var _useState7 = useState(function () {
      return getUserCustomFieldValue();
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    customFieldValues = _useState8[0],
    setCustomFieldValues = _useState8[1];
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    customFieldErrors = _useState10[0],
    setCustomFieldErrors = _useState10[1];
  function getCustomFieldChangeHandler(label) {
    return function (e) {
      e.persist();
      setCustomFieldValues(function (prevValues) {
        var res = _objectSpread({}, prevValues);
        res[label] = _objectSpread(_objectSpread({}, prevValues[label]), {}, {
          value: e.target.value
        });
        return res;
      });
    };
  }
  function getFieldsWithErrors() {
    var errorFields = {};
    Object.entries(customFieldValues).forEach(function (_ref2) {
      var _field$value;
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        field = _ref3[1];
      if (field.is_required && !((_field$value = field.value) !== null && _field$value !== void 0 && _field$value.trim())) {
        var error = t('required_field');
        errorFields[key] = error;
      }
    });
    return errorFields;
  }
  function submitForm(e) {
    e.preventDefault();
    var fieldsWithErrors = getFieldsWithErrors();
    setCustomFieldErrors(fieldsWithErrors);
    if (Object.keys(fieldsWithErrors).length) {
      return;
    }
    updateUserProfile({
      first_name: firstName || '',
      last_name: lastName || '',
      customFields: customFieldValues
    }, {
      onSuccess: function onSuccess() {
        updateUserSettings({
          viewedCompleteProfile: true
        });
        onClose();
        setShowNameForm(false);
      }
    });
  }
  function logout(_x) {
    return _logout.apply(this, arguments);
  }
  function _logout() {
    _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            _context.prev = 1;
            _context.next = 4;
            return logoutUser();
          case 4:
            if (setAuthUser) {
              setAuthUser(null);
            }
            redirectToLogin();
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setAlert({
              title: t('alert_logout_failed'),
              message: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.error
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _logout.apply(this, arguments);
  }
  var formattedMessage = t('complete_profile_message');
  if (completeProfileMessage) {
    var newlineRegexp = /\n\n\n+/g;
    var replacementRegexp = '\n\n';
    formattedMessage = completeProfileMessage.replaceAll(newlineRegexp, replacementRegexp).trim();
  }
  var superuser = hasPrivilege(SUPER_USER);
  var titleId = 'complete-profile-modal-title';
  return /*#__PURE__*/React.createElement(Modal, {
    id: "complete-profile-modal",
    width: "wide",
    onRequestClose: superuser ? onClose : noop,
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Card, {
    variant: "raised",
    as: "form",
    onSubmit: submitForm
  }, /*#__PURE__*/React.createElement(ModalHeadline, {
    title: t('complete_profile_title'),
    titleId: titleId,
    onClose: superuser ? onClose : undefined
  }), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement("p", null, formattedMessage)), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(ShadedCard, null, /*#__PURE__*/React.createElement(Flex, {
    breakpoints: "xxs",
    flexDirection: ['column', 'row']
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    p: "m",
    borderBottom: ['thin', null],
    borderRight: [null, 'thin'],
    textAlign: ['center', 'left'],
    width: "100%",
    breakpoints: "xxs"
  }, !showNameForm && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, userProfile.displayName), Boolean(enableUserEditName) && /*#__PURE__*/React.createElement(TextLink, {
    as: "button",
    onClick: function onClick() {
      return setShowNameForm(true);
    }
  }, t('actions_change_name'))), showNameForm && /*#__PURE__*/React.createElement(FormStack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(FormField, {
    label: t('profile_first_name')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: firstName,
    onChange: function onChange(e) {
      return setFirstName(e.target.value);
    },
    disabled: !enableUserEditName
  })), /*#__PURE__*/React.createElement(FormField, {
    label: t('profile_last_name')
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: lastName,
    onChange: function onChange(e) {
      return setLastName(e.target.value);
    },
    disabled: !enableUserEditName
  })))), /*#__PURE__*/React.createElement(Box, {
    textAlign: "center",
    minWidth: AVATAR_EDITOR_WIDTH,
    maxWidth: "40%",
    p: ['s', 'm'],
    breakpoints: "xxs"
  }, /*#__PURE__*/React.createElement(AvatarEditor, null))))), userProfile.userCustomFields && ((_userProfile$userCust3 = userProfile.userCustomFields) === null || _userProfile$userCust3 === void 0 ? void 0 : _userProfile$userCust3.length) > 0 && /*#__PURE__*/React.createElement(Panel, null, hasRequiredFields && /*#__PURE__*/React.createElement(Text, {
    as: "p",
    dimmed: true,
    size: "s",
    mb: "xs"
  }, t('required_fields_note')), /*#__PURE__*/React.createElement(ShadedCard, {
    p: "s"
  }, /*#__PURE__*/React.createElement(FormStack, null, userProfile.userCustomFields.map(function (_ref4) {
    var _customFieldValues$la;
    var label = _ref4.label,
      id = _ref4.id,
      is_required = _ref4.is_required,
      hint = _ref4.hint;
    return /*#__PURE__*/React.createElement(FormField, {
      key: id,
      label: is_required ? "".concat(label, " *") : label,
      description: hint,
      descriptionType: "tooltip",
      alert: customFieldErrors[label]
    }, /*#__PURE__*/React.createElement(TextInput, {
      value: ((_customFieldValues$la = customFieldValues[label]) === null || _customFieldValues$la === void 0 ? void 0 : _customFieldValues$la.value) || '',
      onChange: getCustomFieldChangeHandler(label),
      required: !!is_required
    }));
  })))), /*#__PURE__*/React.createElement(Panel, {
    align: "center"
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    icon: "ok",
    variant: "primary",
    isDisabled: !!Object.keys(getFieldsWithErrors()).length
  }, t('actions_continue')), /*#__PURE__*/React.createElement(TextLink, {
    as: "button",
    onClick: logout
  }, t('actions_logout'))))));
}
export default CompleteProfileModal;